// Generated by scripts/generate_language_journeys.py.
export const languageJourneyLoaders = {
  french: () => import("./language-journeys/french.json").then((m) => m.default),
  spanish: () => import("./language-journeys/spanish.json").then((m) => m.default),
  dutch: () => import("./language-journeys/dutch.json").then((m) => m.default),
  italian: () => import("./language-journeys/italian.json").then((m) => m.default),
  japanese: () => import("./language-journeys/japanese.json").then((m) => m.default),
  mandarin: () => import("./language-journeys/mandarin.json").then((m) => m.default),
  german: () => import("./language-journeys/german.json").then((m) => m.default),
  portuguese: () => import("./language-journeys/portuguese.json").then((m) => m.default),
  korean: () => import("./language-journeys/korean.json").then((m) => m.default),
  arabic: () => import("./language-journeys/arabic.json").then((m) => m.default),
  english: () => import("./language-journeys/english.json").then((m) => m.default),
  greek: () => import("./language-journeys/greek.json").then((m) => m.default),
};
